import OrderSummaryComponent from "../vue/components/OrderSummaryComponent";
import store from "@continente/vue/components/store";
import { getSVGIcon } from "../utilities/globalUtilities";
import {
    AUTO
} from "../utilities/constants";
import SimpleBar from "simplebar";

const debounce = require("lodash/debounce");
const mqueryRespond = window.mqRespond;

const $cache = {
    window: $(window),
    footerHeight: $("#footercontent").outerHeight()
};

let summarySB;

/**
 * @function
 * @description - Initialize order summary
 * @param {String} el - Order summary element selector
 * @param {Object} orderSummaryData - Order summary data
 * @param {Number} currentStep - Checkout current step
 */
const initOrderSummary = (el, orderSummaryData, currentStep) => {
    const resources = JSON.parse(orderSummaryData);

    store.commit("setOrderSummaryInfo", resources);
    store.commit("setOrderReviewPageBoolean", resources.pageType == resources.pageTypeReviewResource);
    store.commit("setCheckoutPageBoolean", resources.pageType == resources.pageTypeCheckoutResourceDelivery);
    store.commit("setPaymentPageBoolean", resources.pageType == resources.pageTypeCheckoutResourcePayment);

    const data = () => {
        return {
            resources,
            questionMarkIcon: getSVGIcon("icon-question-inverse"),
            entregaZeroIcon: getSVGIcon("icon-entrega-zero"),
            currentStep: currentStep
        };
    };

    const mounted = function () {
        store.watch(() => store.state.orderSummaryInfo, newOrderSummaryData => {
            this.resources = newOrderSummaryData;
        });
    };

    new OrderSummaryComponent({el, store, data, mounted});

    stickySummaryWrapperInit(true);
};

/**
 * @function
 * @description - Summary top positioning
 */
const setTopSummaryPosition = () => {
    if (!$("body").hasClass("modal-open")) {
        const scrollTop = $("body").hasClass("modal-open")
            ? $(document).scrollTop()
            : $(window).scrollTop();

        const minTop = $cache.summaryWrapperBaseTop - $("header").outerHeight();
        const newTop = Math.max($cache.summaryWrapperBaseTop - scrollTop, minTop);

        $cache.summaryWrapper.css("top", newTop + "px");
    }
};

/**
 * @function
 * @description - Clear summary height
 */
const clearInnerSummaryHeight = () => {
    const summaryContainer = document.querySelector(".ct-cart--summary-wrapper");
    const summarySection = document.querySelector(".ct-cart--summary-details-container");
    summaryContainer.style.height = AUTO;
    summarySection.style.height = AUTO;
};

/**
 * @function
 * @description - Inner summary height handling to enable scroll if viewport smaller than summary container
 */
const handleInnerSummaryHeight = () => {
    clearInnerSummaryHeight();

    const summarySection = document.querySelector(".ct-cart--summary-details-container");

    const maxHeight = window.innerHeight / 3 - (mqueryRespond.status.mobile || mqueryRespond.status.tablet ? 0 : 20);
    summarySection.style.maxHeight = `${maxHeight}px`;
};

/**
 * @function
 * @description - Summary container Simplebar init
 */
const summaryWrapperSimpleBar = () => {
    const summarySimpleBarContainer = document.getElementById("summary-section-simplebar");

    if (typeof summarySB == "undefined") { //mqueryRespond.status.desktop || mqueryRespond.status.desktopLarge &&
        summarySB = new SimpleBar(summarySimpleBarContainer);
    }
};

/**
 * @function
 * @description - Summary position handlers
 */
const summaryPositionHandlers = () => {
    //setBottomSummaryPosition();
    summaryWrapperSimpleBar();
    handleInnerSummaryHeight();
};

/**
 * @function
 * @description - Summary description related events
 */
const stickySummaryWrapperInit = (vueSummaryComponent) => {
    if (!(mqueryRespond.status.mobile || mqueryRespond.status.tablet)) {

        $cache.summaryWrapper = $(".ct-cart--summary-wrapper");
        $cache.summaryWrapperBaseTop = parseInt($cache.summaryWrapper.css("top"), 10);

        $(window).on("load", setTopSummaryPosition)
            .on("scroll", setTopSummaryPosition)
            .on("resize", debounce(() => {
                setTopSummaryPosition();
            }, 10));
    }

    if (vueSummaryComponent) {
        document.addEventListener("page.minHeightSet", () => {
            summaryPositionHandlers();
        });
    }
};

export { initOrderSummary, stickySummaryWrapperInit };
